module.exports = __webpack_public_path__ + "img/kid-more.9c3a8c7c.png";